import React, { useEffect, useState } from 'react';
import { Text } from '@oneaudi/unified-web-components';
import { DangerousElement } from '../../../../components';
import { readFinance, getValueFromPath } from '../../../utils';
import { useServicesContext } from '../../../../context';
import { DisclaimerContainer } from './styles/FinanceRethink.styles';
import { useFinance } from './FinanceContext';
export const Disclaimer = ({ vehicleBasic, isPlp }) => {
    var _a, _b, _c, _d;
    const { getConfiguration } = useServicesContext();
    const { disclaimerTypePathInPDP, disclaimerType: configuredDisclaimer } = getConfiguration() || {};
    const dynamicFinance = !isPlp && (vehicleBasic === null || vehicleBasic === void 0 ? void 0 : vehicleBasic.financing) ? (_a = useFinance()) === null || _a === void 0 ? void 0 : _a.dynamicFinance : {};
    const [selectedDisclaimer, setSelectedDisclaimer] = useState(null);
    const disclaimerMapFromSCS = {
        global: (_b = vehicleBasic === null || vehicleBasic === void 0 ? void 0 : vehicleBasic.financing) === null || _b === void 0 ? void 0 : _b.globalDisclaimer,
        product: (_c = vehicleBasic === null || vehicleBasic === void 0 ? void 0 : vehicleBasic.financing) === null || _c === void 0 ? void 0 : _c.productDisclaimer,
        calculation: (_d = vehicleBasic === null || vehicleBasic === void 0 ? void 0 : vehicleBasic.financing) === null || _d === void 0 ? void 0 : _d.calculationDisclaimer,
    };
    useEffect(() => {
        if (isPlp) {
            setSelectedDisclaimer(disclaimerMapFromSCS[configuredDisclaimer === null || configuredDisclaimer === void 0 ? void 0 : configuredDisclaimer.toLowerCase()]);
        }
    }, []);
    useEffect(() => {
        var _a;
        if (!isPlp) {
            const result = readFinance(vehicleBasic.type);
            if (result) {
                const disclaimersFromStorage = (_a = result === null || result === void 0 ? void 0 : result.financing[vehicleBasic.id]) === null || _a === void 0 ? void 0 : _a.financeResponseData;
                const disclaimerInPDP = disclaimersFromStorage && disclaimerTypePathInPDP
                    ? getValueFromPath(disclaimersFromStorage, disclaimerTypePathInPDP)
                    : '';
                setSelectedDisclaimer(disclaimerInPDP);
            }
            else {
                setSelectedDisclaimer(null);
            }
        }
    }, [dynamicFinance, disclaimerTypePathInPDP]);
    if (!selectedDisclaimer) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(DisclaimerContainer, null,
            React.createElement(Text, { tag: "span", variant: { type: 'copy', order: '2', style: 'normal' } },
                React.createElement(DangerousElement, { as: "span", html: selectedDisclaimer })))));
};
